import React from 'react';
import "./quote.css"
import logo from './logo.svg';

import QuestionModal from "./QuestionModal";
import DetailsModal from "./DetailsModal"

export default class Quotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reference: '',
      submittedRef: '',
      refType: '',
      refData: [],
      delAddr: null,  
      invAddr: null,
      showOverLimitMessage: false,
      quoteAccepted:false,
      showDeclineModal: false,
      showAcceptModal: false,
      declineFeedback: '',
      declined:false,
      NSacceptTerms:false,
    };
  }

  handleChange = (e) => {
    this.setState({ reference: e.target.value });
  };

componentDidMount() {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get("ref");

  if (ref && ref.trim() !== "") {
    this.setState({ reference: ref }, () => {
      // Automatically submit after state is set
      this.handleSubmit({ preventDefault: () => {} });
    });
  }
}

  handleSubmit = async (e) => {
  e.preventDefault();

  const { reference } = this.state;

  if (reference.trim() === '') {
    alert('Please enter a valid reference');
    return;
  }

  try {
    const formData = new FormData();
    const formData2 = new FormData();
    formData.append('reference', reference);

    const response = await fetch('https://payments.fhbrundle.co.uk/api?cmd=ref_lookup', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data && data.ref_type && data.ref_data) {
  this.setState({
    submittedRef: reference,
    refType: data.ref_type,
    refData: data.ref_data,
    delAddr: data.del_addr || null,
    invAddr: data.inv_addr || null,
    declined: data.ref_type === "quote_declined",
    quoteConverted: data.ref_type === "quote_complete",
    convertedRef: data.ref_type === "quote_complete" ? data.ref : '',
    convertedCustomer: data.ref_type === "quote_complete" ? data.customer : '',
  });

  
    formData2.append("ref", reference);
    formData2.append("type", "quote");
    formData2.append("info", "opened");
    formData2.append("text", "");
    if(reference!=""){
      const response2 = await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
        method: "POST",
        body: formData2,
      });
    }
}else {
      alert(data.message || 'No result found.');
      this.setState({ submittedRef: reference, refType: '', refData: null });
    }
  } catch (error) {
    console.error('Lookup failed:', error);
    alert('There was an error contacting the server.');
  }
};


accept_quote = async (cust, ref,extra) => {
  try {
    const formData = new FormData();
    formData.append('type', 'quote');
    formData.append('ref', ref);
    formData.append('customer', cust);
    formData.append('their_ref', extra.current_ref); // 
    formData.append('due_date', extra.due_date); // 
    formData.append('notes', extra.notes); // 
  try{
    formData.append('terms', extra.terms); // 
    }catch(err){}

    const response = await fetch('https://payments.fhbrundle.co.uk/api?cmd=ref_convert', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
       this.setState({
        refType: '',
        refData: [],
        submittedRef: '',
        delAddr: null,
        invAddr: null,
        showOverLimitMessage: false,
        quoteAccepted: true,  // <-- flag to show confirmation
        editableTheirRef:""
      });
      // Optional: refresh page or redirect
    } else {
      alert(data.reason || 'Failed to accept quote.');
    }
  } catch (err) {
    console.error(err);
    
  }
};

generate_request = async (cust,ref,extra) => {

 const total = parseFloat(this.state.refData[0].sopq_invval);
  
  if (total > 10000) {
    this.setState({ showOverLimitMessage: true });
    return;
  }

  const transactions = [{ type: "quote", ref: ref }];

  const jsonString = JSON.stringify({ transactions });
  const base64Encoded = btoa(jsonString);

    const formData = new FormData();
    formData.append("ref", this.state.submittedRef);
    formData.append("type", "quote");
    formData.append("info", "worldpay");
    formData.append("text", "");
    formData.append('their_ref', extra.current_ref); // 
    formData.append('due_date', extra.due_date); // 
    formData.append('notes', extra.notes); // 
    try{
    formData.append('terms', extra.terms); // 
    }catch(err){
      
    }

    const response2 = await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });


  try {
    const safeCust = encodeURIComponent(cust || 'UNKNOWN');

    const response = await fetch(
      `https://payments.fhbrundle.co.uk/api?cmd=build_transaction&cust=${safeCust || 'UNKNOWN'}`,
      {
        method: 'POST',
        body: base64Encoded,
      }
    );





    const data = await response.json();

    if (data.URL) {
      this.setState({ URL: data.URL });
      window.location = data.URL;
    } else {
      alert(data.reason || 'Payment request failed.');
    }
  } catch (err) {
    console.error(err);
    alert("There was a problem starting the payment process.");
  }
};

hasRestrictedProducts = () => {
  const { refData } = this.state;
  if (!Array.isArray(refData)) return false;

  return refData.some(item => {
    const productMatch =
      item.product &&
      (item.product.startsWith("CUT") || item.product === "NS");

    const notepadMatch =
      item.notepad && item.notepad.includes("CUT");

    return productMatch || notepadMatch;
  });
};

openDeclineModal = async() => {
  console.log("Decline button pressed.");


 const formData = new FormData();
    formData.append("ref", this.state.submittedRef);
    formData.append("type", "quote");
    formData.append("info", "decline_pressed");
    formData.append("text", "");

    const response = await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

  this.setState({ showDeclineModal: true });
};

closeDeclineModal = () => {
  this.setState({ showDeclineModal: false, declineFeedback: '' });
};

submitDeclineFeedback = async () => {
  const { submittedRef, declineFeedback } = this.state;
this.setState({declined:true})
    this.closeDeclineModal();
//  if (!declineFeedback.trim()) {
 //   alert("Please enter your feedback.");
 //   return;
 // }

  try {

    const formData = new FormData();
    formData.append("ref", submittedRef);
    formData.append("type", "quote");
    formData.append("info", "decline");
    formData.append("text", declineFeedback);

    const response = await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    //if (data) {
    //  alert("Thank you for your feedback.");
      this.closeDeclineModal();
    //} else {
    //  alert(data.message || "Failed to submit feedback.");
    //}
  } catch (error) {
    //console.error("Error submitting feedback:", error);
    //alert("There was a problem submitting your feedback.");
  }
};

acceptModalStart=()=>{
  this.setState({ showAcceptModal: true});
}

closeAcceptModal=()=>{
 this.setState({ showAcceptModal: false});

}
  
quote_modal_confirm=(extra)=>{
  this.setState({ showAcceptModal: false});
  if((this.state.refData[0].pay_type=="P" || this.state.refData[0].pay_type=="C")){
    this.generate_request(this.state.refData[0].sopq_custr,this.state.refData[0].sopq_ref,extra)

  }else{
    this.accept_quote(this.state.refData[0].sopq_custr,this.state.refData[0].sopq_ref,extra)
  }

   


/*
{(this.state.refData[0].pay_type=="P" || this.state.refData[0].pay_type=="C") ? (
<button className="pay_button"   onClick={() => this.generate_request(this.state.refData[0].sopq_custr,this.state.refData[0].sopq_ref)}>
Make payment 
</button>
):(
<button className="pay_button"  onClick={() => this.accept_quote(this.state.refData[0].sopq_custr,this.state.refData[0].sopq_ref)}>
Accept Quote
</button>    
)}
*/



}


render() {

  const hasRestricted = this.hasRestrictedProducts();

const pay =
  this.state.refData && this.state.refData[0]
    ? this.state.refData[0].pay_type === "P" || this.state.refData[0].pay_type === "C"
    : false;

const their_ref=this.state.refData && this.state.refData[0] ?this.state.refData[0].sopq_their :""
  return (
    <div className="App">
           <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
              </header>
      
        <h4>Enter reference</h4>
      

      <form onSubmit={this.handleSubmit} style={{ margin: '20px' }}>
        <div>
          <input
            type="text"
            name="reference"
            value={this.state.reference}
            onChange={this.handleChange}
            placeholder="Enter quote reference"
            className="form_input"
          />
        </div>

        <div style={{ marginTop: '10px' }}>
          <button type="submit" className="lookup_link">
            <div>Submit</div>
          </button>
        </div>
      </form>

 {this.state.submittedRef && (!this.state.refType || !this.state.refData) && (
  <div className="pad10" style={{ marginTop: '20px' }}>
    <strong>Looking up:</strong> {this.state.submittedRef}
  </div>
)}
{this.state.submittedRef && (!this.state.refType || !this.state.refData || this.state.refData.length === 0) && (
  <div className="no_results_message" style={{ marginTop: '20px', color: 'white' }}>
    No results found for reference <strong>{this.state.submittedRef}</strong>.
  </div>
)}




<div id="quote_container">

  {this.state.refType === 'quote_complete' && this.state.quoteConverted && (
  <div className="quote_converted_msg">
    <div className="tick">✓</div>
    <div>
      Quote <strong>{this.state.convertedRef}</strong> has been successfully converted to order.
    </div>
  </div>
)}
      {/* Here's the dynamic result display based on ref_type */}

{this.state.showOverLimitMessage && (
  <div className="limit_warning" style={{ marginTop: '20px', color: '#ffcc00', fontWeight: 'bold' }}>
    Orders over £10,000 cannot be performed online. Please call your sales office.
  </div>
)}


{this.state.declined===true && (

<div className="quote_accepted_msg">
    <div className="tick">X</div>
    <div>Quote Declined.</div>
  </div>

)}

{this.state.quoteAccepted && (
  <div className="quote_accepted_msg">
    <div className="tick">✓</div>
    <div>Quote accepted successfully.</div>
  </div>
)}


<DetailsModal
  visible={this.state.showAcceptModal}
  onClose={this.closeAcceptModal}
  onSubmit={this.quote_modal_confirm}
  current_ref={their_ref}
  termsRequired={hasRestricted}
  pay={pay}
  due_date ={""}
  notes ={""}
/>



<QuestionModal
  visible={this.state.showDeclineModal}
  onClose={this.closeDeclineModal}
  onSubmit={this.submitDeclineFeedback}
  feedback={this.state.declineFeedback}
  setFeedback={(text) => this.setState({ declineFeedback: text })}
/>


{this.state.refType === 'quote' && Array.isArray(this.state.refData) && this.state.refData.length > 0 && (
<div className="quote_container">
 <div className="quote_summary">
    
    <div className="quote_summary_ref">
      <div><span className="summary_label">Our ref:</span> {this.state.refData[0].sopq_ref}</div>
      <div><span className="summary_label">Your ref:</span> {this.state.refData[0].sopq_their}</div>
    {/*   <input
    type="text"
    value={this.state.editableTheirRef}
    onChange={(e) => this.setState({ editableTheirRef: e.target.value })}
    className="your_ref_input"
    style={{ marginLeft: '10px', padding: '4px' }}
  />*/}
    </div>


 <div className="quote_summary_del_addr">
    {this.state.delAddr && (
      <div>
        <div className="summary_label">Delivery Address</div>
        <div>{this.state.delAddr.del_name}</div>
        <div>{this.state.delAddr.del_add1}</div>
        <div>{this.state.delAddr.del_add2}</div>
        <div>{this.state.delAddr.del_add3}</div>
        {this.state.delAddr.del_add4 && <div>{this.state.delAddr.del_add4}</div>}
        <div><b>{this.state.delAddr.del_postcode}</b></div>
      </div>
    )}
  </div>

  <div className="quote_summary_inv_addr">
    {this.state.invAddr && (
      <div>
        <div className="summary_label">Invoice Address</div>
        <div>{this.state.invAddr.cus_name}</div>
        <div>{this.state.invAddr.cus_add1}</div>
        <div>{this.state.invAddr.cus_add2}</div>
        <div>{this.state.invAddr.cus_add3}</div>
        {this.state.invAddr.cus_add4 && <div>{this.state.invAddr.cus_add4}</div>}
        <div><b>{this.state.invAddr.cus_postcode}</b></div>
      </div>
    )}
  </div>


  </div>
  </div>
)}



      
     {this.state.refType === 'quote' && Array.isArray(this.state.refData) && this.state.refData.length > 0 && (<div className="ProductLanding quote">
  <div className="ProductLandingGrid">
    {this.state.refData.map((item, index) => (
      <div key={index} className="product_table prodlayoutdefault">
        <div className="product_card_img_container">
          <a
            className="product_card_link"
            href={`https://www.fhbrundle.co.uk/products/${item.product}?utm_source=pbl&utm_medium=quote&utm_campaign=${this.state.submittedRef}`}
          >
           <img
  className="product_card_img"
  src={`https://samsara-web.s3-eu-west-1.amazonaws.com/webimages/${item.product}/${item.product}x140.jpg`}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src =
      'data:image/svg+xml;base64,' +
      btoa('<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="white"/></svg>');
  }}
  alt={item.product}
/>
          </a>
        </div>
        <div className="product_card_content">
          <div className="product_card_desc">
            <a
              className="product_card_link"
              href={`https://www.fhbrundle.co.uk/products/${item.product}__${item.desc.replaceAll(
                ' ',
                '_'
              )}?utm_source=pbl&utm_medium=quote&utm_campaign=${this.state.submittedRef}`}
            >
              {item.desc}
            </a>
          </div>
          <div className="product_card_code">{item.product}</div>
          {item.notepad && item.notepad !== "@@" && (
  <div className="product_card_note">{item.notepad.replaceAll("@","")}</div>
)}

          <div className="product_card_bottom">
          <div className="prod_price">
                <div className="quote_item">
                    <div className="quote_label">QUOTED QTY</div>
                    <div className="quote_value">x{parseFloat(item.qty).toFixed(2)}</div>
                </div>
                <div className="quote_item">
                    <div className="quote_label">PRICE</div>
                    <div className="quote_value">£{parseFloat(item.price).toFixed(2)}</div>
                </div>
                <div className="quote_item">
                    <div className="quote_label">LINE TOTAL</div>
                    <div className="quote_value">£{parseFloat(item.line_price).toFixed(2)}</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>
)}
{this.state.showOverLimitMessage && (
  <div className="limit_warning" style={{ marginTop: '20px', color: '#ffcc00', fontWeight: 'bold' }}>
    Orders over £5,000 cannot be performed online. Please call your sales office.
  </div>
)}
{this.state.refType === 'quote' && Array.isArray(this.state.refData) && this.state.refData.length > 0 && (
<div className="quote_container">
 <div className="quote_summary_val">
    
    <div className="quote_summary_values">
      <div><span className="summary_label">Subtotal (ex VAT):</span> £{parseFloat(this.state.refData[0].sopq_invgds).toFixed(2)}</div>
      <div><span className="summary_label">Total (inc VAT):</span> <strong>£{parseFloat(this.state.refData[0].sopq_invval).toFixed(2)}</strong></div>
    </div>
  </div>
  </div>
)}


{this.state.refType === 'quote' && Array.isArray(this.state.refData) && this.state.refData.length > 0 && (
<div className="quote_container">
 <div className="quote_summary">
    
    <div className="quote_actions">
        

<button className="pay_button"   onClick={() => this.acceptModalStart()}>
Accept Quote
</button>



<button className="pay_button decline_but" onClick={this.openDeclineModal}>
  Decline Quote
</button>

        {!hasRestricted && (
  <button className="pay_button" onClick={() =>
    window.location.href = `https://www.fhbrundle.co.uk/basket?loadBasket=${encodeURIComponent(this.state.submittedRef)}&utm_source=pbl&utm_medium=quote&utm_campaign=${this.state.submittedRef}`
  }>
    Edit Quote Online
  </button>
)}  
 
    </div>
  </div>
  </div>
)}
{this.state.showOverLimitMessage && (
  <div className="limit_warning" style={{ marginTop: '20px', color: '#ffcc00', fontWeight: 'bold' }}>
    Orders over £5,000 cannot be performed online. Please call your sales office.
  </div>
)}

</div>
    </div>
  );
}
}
